export const STORAGE_FILTER = '@UnimedFilterConsulta';

const DateToLS = (date: unknown) => {
  if (!date) return '';
  const [day, month, year] = (date as string).split('/').map(Number);
  return [year, month - 1, day];
};
export function saveFilterLocalStorage(data: Record<string, unknown>): void {
  try {
    localStorage.setItem(
      STORAGE_FILTER,
      JSON.stringify({
        prevFilter: {
          ...data,
          startDate: DateToLS(data.startDate),
          endDate: DateToLS(data.endDate),
        },
        goBackClicked: false,
      }),
    );
  } catch (err) {
    console.error('Erro ao salvar dados no localStorage', err);
  }
}

export const removeFilterLocalStorage = (): void => {
  localStorage.removeItem(STORAGE_FILTER);
};

interface ReturnLoadingDataFilterLocalStorage {
  doctor: string;
  startDate: Date | null;
  endDate: Date | null;
  speciality: string;
  city: string;
  typeId: string;
}

const LSDate = (date: unknown) => {
  return date ? new Date(...(date as [number, number, number]), 0, 0, 0) : null;
};
export function loadingDataFilterLocalStorage(): ReturnLoadingDataFilterLocalStorage {
  try {
    const local = localStorage.getItem(STORAGE_FILTER);
    if (local) {
      const parsed = JSON.parse(local);
      const { prevFilter, goBackClicked } = parsed;
      if (!goBackClicked) {
        return {} as ReturnLoadingDataFilterLocalStorage;
      }
      const formattedData = {
        ...prevFilter,
        startDate: LSDate(prevFilter.startDate),
        endDate: LSDate(prevFilter.endDate),
        typeId: prevFilter.typeId,
        doctor: prevFilter.doctorName ?? '',
      };

      return formattedData as ReturnLoadingDataFilterLocalStorage;
    }
    return {} as ReturnLoadingDataFilterLocalStorage;
  } catch (error) {
    console.error('Erro ao buscar os dados do localStorage', error);
    return {} as ReturnLoadingDataFilterLocalStorage;
  } finally {
    removeFilterLocalStorage();
  }
}

export const getTypeIdFromLocalStorage = (): string | null => {
  try {
    const local = localStorage.getItem(STORAGE_FILTER);
    if (!local) return null;
    const parsed = JSON.parse(local);
    const { prevFilter } = parsed;
    return prevFilter.typeId ?? null;
  } catch (err) {
    return null;
  }
};

export const handleGoBackClicked = (): void => {
  try {
    const local = localStorage.getItem(STORAGE_FILTER);
    if (!local) return;
    const parsed = JSON.parse(local);
    localStorage.setItem(
      STORAGE_FILTER,
      JSON.stringify({
        ...parsed,
        goBackClicked: true,
      }),
    );
  } catch (err) {
    //
  }
};
